import Ad from 'src/components/ads/Ad';
import type { ILoaderMoviesProps } from 'src/lib/types/filminfo/ILoaderMoviesProps';
import MonthlyMovies from 'src/components/kommendefilmer/MonthlyMovies';
import { isPremiereThisWeek, isTooFarAhead } from 'src/components/kommendefilmer/helperFunctions';
import { addYears, parseISO } from "date-fns";
import type { Movie } from 'src/lib/movieinfo/movieinfotypes';
import { groupBy } from 'lodash';
import React from 'react';
const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type MoviesByMonthProps = {
  adKeys: string[];
  showTextList?: boolean;
} & ILoaderMoviesProps;
//#endregion

//#region [Component]
export default function MoviesByMonth({
  movies,
  adKeys,
  showTextList = false
}: MoviesByMonthProps) {
  const kinoDkFutureCutoff = addYears(new Date(), 5);
  const _movies = movies?.filter(m => !isPremiereThisWeek(m) && !isTooFarAhead(m, kinoDkFutureCutoff));
  const groupedMovies = groupBy(_movies, grouper);
  const keys = Object.keys(groupedMovies).map(key => Number(key)).sort();
  let adIdx = 0;
  return keys.map(monthKey => {
    const movies = groupedMovies[monthKey.toString()];
    const shouldShowAd = BRAND === "kinodk" ? adIdx < adKeys.length : movies.length >= 7 && adIdx < adKeys.length;
    return <React.Fragment key={monthKey}>
            {BRAND === "filmweb" && shouldShowAd && <Ad targetId={adKeys[adIdx++]} removeIfNoAd supportsFixedAd height="300" mobileScreenWidth />}
            <MonthlyMovies monthKey={monthKey} movies={movies} showTextList={showTextList} />
            {BRAND === "kinodk" && shouldShowAd && <Ad targetId={adKeys[adIdx++]} removeIfNoAd mobileScreenWidth />}
        </React.Fragment>;
  });
}
//#endregion

function grouper(movie: Movie): number {
  const d = parseISO(movie.premiere!);
  return d.getFullYear() + (d.getMonth() + 1) / 100.0;
}